<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="relative z-30" @close="close">
      <DialogOverlay
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
      />

      <div class="fixed z-40 inset-0 overflow-y-auto">
        <div
          class="flex items-end sm:items-center justify-center min-h-full p-4 sm:p-0"
        >
          <DialogPanel
            class="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6"
          >
            <div>
              <div
                v-if="hasCloseButton"
                class="block absolute top-0 right-0 pt-4 pr-4"
              >
                <button
                  type="button"
                  class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
                  @click="$emit('close')"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div class="mt-3 text-center sm:mt-5">
                <DialogTitle
                  as="h3"
                  class="text-lg leading-6 font-medium text-gray-900"
                >
                  <slot name="header"></slot>
                </DialogTitle>
                <div class="mt-2">
                  <slot name="body"></slot>
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-6">
              <slot name="footer"></slot>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import {
  Dialog,
  DialogOverlay,
  DialogPanel,
  DialogTitle,
  TransitionRoot,
} from "@headlessui/vue";
import { ref, watch } from "vue";
import { defineProps, defineEmits } from "vue";

defineProps({
  open: Boolean,
  class: String,
  hasCloseButton: Boolean,
});

const emit = defineEmits(["close"]);

const close = () => {
  emit("close");
};
</script>
